import { createClient } from '@/shared/api';
import type {
  ExtendActiveSessionMutation,
  ExtendActiveSessionMutationVariables,
} from '@/shared/api';
import EXTEND_ACTIVE_SESSION_MUTATION from '../mutations/extendActiveSession';

/**
 * Extends the signed-in user's active session so the idle timeout is pushed back. Runs EXTEND_ACTIVE_SESSION_MUTATION and throws the returned message when isSuccess is false.
 *
 * @returns A promise resolving once the mutation result has been checked for success.
 */
const handleExtendActiveSession = async () => {
  const client = createClient();
  const result = await client.mutate<
    ExtendActiveSessionMutation,
    ExtendActiveSessionMutationVariables
  >({
    mutation: EXTEND_ACTIVE_SESSION_MUTATION,
  });
  // result.data is guaranteed by the mutation contract; downstream code already assumes it exists
  if (!result.data!.extendActiveSession.isSuccess) {
    throw new Error(result.data!.extendActiveSession.message ?? undefined);
  }
};

export default handleExtendActiveSession;
